export default __webpack_public_path__ + "static/HeaderImage-1-min-035396297b6c18c14eb93493ea40636f.jpg";